import React, { useEffect, useState } from "react";
import { ButtonGroup, Col, Form, Modal, Row} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Navbar from "../../../Components/Navbar/Navbar";
import Table from "../../../Components/TableTemplate/Table";
import {
    getType,
    toastStyle,
    formatTime,
    refreshPage,
    dateFormat,
    selectDropdownStyle,
    getBranchId,
} from "../../../Helpers/Utils/Common";
import DatePicker from "react-datepicker";
// import * as XLSX from "xlsx";
import "../../../Helpers/Utils/Common.css";
import "./../../Purchases/Purchase Invoice/PurchaseInvoices.css";

import { getAllBranches } from "../../../Helpers/apiCalls/Manage/Branches";
// import { getAllItems } from "../../../Helpers/apiCalls/itemsApi";
import { deleteGatePass, getAllGatePass } from "../../../Helpers/apiCalls/Inventory/GatePassApi";
import DeleteModal from "../../../Components/Modals/DeleteModal";
import { toast } from "react-toastify";
import { searchTransfers } from "../../../Helpers/apiCalls/Inventory/TransferApi";
import Select from "react-select";
import Footer from "../../../Components/Footer/Footer";
import TableWithDynamicPagination from "../../../Components/TableTemplate/TableWithDynamicPagination";


export default function GatePass() {
    let navigate = useNavigate();
    const accountType = getType();
    const [inactive, setInactive] = useState(true);
    const [filterConfig, setFilterConfig] = useState({
        branch_id: (accountType === "branch_oic" || accountType === "branch_inventory_officer") ? getBranchId() : "",
        page: 1
    })
    const [totalItems, setTotalItems] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10; // Change this based on your requirement

    const [branches, setBranches] = useState([]);
    const [showLoader, setShowLoader] = useState(false);
    const [tableData, setTableData] = useState([]);
    // const [items, setItems] = useState([]);
    const [isClicked, setIsClicked] = useState(false);
    const [transfers, setTransfers] = useState([]);
    const [transferId, setTransferId] = useState("");


     /* delete modal handler */
     const [showAddModal, setShowAddModal] = useState(false);
     const [showDeleteModal, setShowDeleteModal] = useState(false);
     const handleShowDeleteModal = () => setShowDeleteModal(true);
     const handleCloseDeleteModal = () => setShowDeleteModal(false); 
     const [selectedRow, setSelectedRow] = useState([]);

    // SEARCH USER
    function handleOnSearch(e) {
        const { name, value } = e.target;
        setFilterConfig((prev) => {
            return { ...prev, [name]: value };
        });
    }

    const handlePageChange = page => {
        setCurrentPage(page);
        setFilterConfig(prev => ({
        ...prev,
        page: page,
        }));
    };

  async function handleSelectChange(e, row) {
    setSelectedRow(row);
    
    if (e.target.value === "view") {
      navigate("/transfers/view/" + row.transfer_id + "/incomplete");
    } else if (e.target.value === "edit") {
      navigate("/gatepass/edit/" + row.id);
    } else if (e.target.value === "delete") {
      handleShowDeleteModal();
    }
    
  }

    function ViewBtn(row) {
        return (
            <button
                name="action"
                className="btn btn-sm view-btn-table"
                id={row.id}
                onClick={() => handlePrint(row)}
                // value="payment-pi"
            >
                View
            </button>
        );
    }
    function handlePrint(row) {
        window.open('/gatepass/view/' + row.id ,'_blank')
    }


    function ActionBtn(row) {
        //
        return (
        <Form.Select
            name="action"
            className="PO-select-action"
            id={row.id}
            onChange={(e) =>
                handleSelectChange(e, row)
            }
        >
            <option value="" selected hidden>
            Select
            </option>

            <option value="view" className="color-options">
                View
            </option>
            <option value="edit" className="color-options">
                Edit
            </option>
            {accountType === "admin" && (
                <option value="delete" className="color-red">
                Delete
                </option>
            )}
        </Form.Select>
        );
    }

    async function fetchBranches() {
        setShowLoader(true);

        const response = await getAllBranches();
        if (response.error) {
        } else {
            var allBranches = response.data.data.data.map((data) => {
                var branch = data;
                branch.label = data.name
                branch.value = data.id
                return branch;
            });
            if(accountType === "branch_oic" || accountType === "branch_inventory_officer") {
                var filteredBranch = allBranches.filter((data) => {
                return data.value === getBranchId()
                })
                setBranches(filteredBranch);
            } else {
                setBranches([{label: "All Branches", value:""}, ...allBranches]);
            }
        }
        setShowLoader(false);
    }

  async function fetchTransfers() {
        setShowLoader(true);
        setTransfers([]);
        
        const response = await searchTransfers({transfer_status: "approved"});
        if (response.data) {
            var allTransfer = response.data.data.map((data) => {
                var info = {};
                info.label = "Transfer No. " + data.transfer_number
                info.value = data.id + "|" + data.branch_from + "|" + data.branch_from_name
                return info;
            })
        }

        setTransfers(allTransfer);

    }

    async function fetchData() {
        setShowLoader(true);
        setTableData([])
        setTotalItems(0)
        // setExcelData([])
        var allData = [];
        // var allExcel = [];

        const response = await getAllGatePass(filterConfig);

        if (response.data){
            var allData = response.data.data.map((data) => {
                var info = data;
                info.transfer_time = formatTime(data.transfer_time)
                info.transfer_date = dateFormat(data.transfer_date)
                allData.push(info);
                return info;
            });

            // var excel = allData.map((data) => {
            //     var info = {};
            //     info.total_transfers = data.total_transfers
            //     info.total_quantity = data.total_quantity
            //     info.name = data.name
            //     info.unit = data.unit
            //     info.total_qty = data.total_qty
            //     info.source_branch = data.source_branch
            //     info.destination_branch = data.destination_branch
            //     allExcel.push(info);
            //     return info;
            // });
        }

        setTableData(allData)
        setTotalItems(response.data.size);
        // setExcelData(allExcel)
        setShowLoader(false);
    }
    
    async function handleDeleteGatePass() {
        setIsClicked(true);
       
        const response = await deleteGatePass(selectedRow.id);
        if (response.data.response === "Transfer deleted successfully.") {
            toast.success("Transfer deleted successfully", {
            style: toastStyle(),
            });
            setTimeout(() => {
            handleCloseDeleteModal();
            refreshPage();
            }, 1000);
        } else {
            toast.error(response.data.response, {
            style: toastStyle(),
            });
            handleCloseDeleteModal();
            refreshPage();
        }
    }

    // function handleExport() {
    //     const rows = excelData
        
    //     /* generate worksheet and workbook */
    //     const worksheet = XLSX.utils.json_to_sheet(rows);
    //     const workbook = XLSX.utils.book_new();
    //     XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet 1");
    //     XLSX.utils.sheet_add_aoa(worksheet, [xlsxHeaders], { origin: "A1" });
    //     XLSX.writeFile(workbook, "TransferHistory.xlsx", { compression: true });
    // }

    useEffect(() => {
        fetchTransfers()
        fetchBranches();
    }, []);

    useEffect(() => {
        fetchData();
    }, [filterConfig, currentPage]);

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilterConfig((prev) => {
        return {
            ...prev,
            [name]: value,
        };
        });
    };

    function TransferBtn(row) {
        return (
        <ButtonGroup vertical>
            <>
            {row.transfers?.map((row) => {
                return (
                <button
                    type="button"
                    className="button-secondary table-button p-1 me-3"
                    onClick={() => handleViewTransfer(row.id, row.status)}
                >
                    {`No.${row.id}`}
                </button>
                );
            })}
            </>
        </ButtonGroup>
        );
    }
    function handleViewTransfer(id, status) {
        window.open("/transfers/view/" + id + "/" + status, "_blank");
    }


    return (
        <div>
            <div className="page">
                <Navbar
                    onCollapse={(inactive) => {
                        setInactive(inactive);
                    }}
                    active={"TRANSFERS"}
                />
            </div>

            <div
                className={`manager-container ${
                    inactive ? "inactive" : "active"
                }`}
            >
                {/* headers */}
                
                <Row className="mb-4">
                    <Col xs={12} lg={7}>
                        <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2"> GATE PASS </h1>
                    </Col>
                    <Col xs={12} lg={3} className="d-flex justify-content-end force-width flex-column flex-lg-row gap-3">
                        <input
                            type="search"
                            name="transfer_no"
                            className="search-bar"
                            placeholder="Search transfer no..."
                            onKeyPress={(e) =>
                                e.key === ("Enter" || "NumpadEnter") && handleFilterChange(e)
                            }
                        />
                    </Col>
                    <Col lg={2} className="mt-4 mt-lg-0">
                        <div className="PO-filters">
                            <button
                                className="add-btn"
                                onClick={() => setShowAddModal(true)}
                            >
                                Add
                            </button>
                        </div>
                    </Col>
                </Row>

                {/* <Row>
                    <Col className="d-flex justify-content-end mb-3">
                        <div className="d-flex justify-content-end">
                            <button
                                type="button"
                                className="button-primary"
                                onClick={handleExport}
                            >
                                <span className="me-2">
                                    <img
                                        alt="download"
                                        width={20}
                                        height={20}
                                        src={downloadIcon}
                                    ></img>
                                </span>
                                Download
                            </button>
                        </div>
                    </Col>
                </Row> */}

                <div className="tab-content">
                    {/* filters */}
                    <div className="mb-3" />
                    <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
                        Filter By:
                    </span>
                    <Row className="PO-filters flex flex-row mx-2 my-1">
                        <Col xs={6} lg={4} className="mb-2 mb-lg-0">
                            <Select
                                className="dropsearch-filter"
                                classNamePrefix="react-select"
                                placeholder="Select Branch"
                                styles={selectDropdownStyle}
                                // value={branchFrom}
                                options={branches}
                                onChange={(e) => {
                                    setFilterConfig((prev) => {
                                        return { ...prev, "branch_id": e.value };
                                    });
                                }}
                            />
                        </Col>
                        <Col xs={6} lg={4} className="mb-2 mb-lg-0">
                            <Form.Select
                                type="select"
                                className="date-filter force-width w-full"
                                classNamePrefix="react-select"
                                placeholder="Type..."
                                name="type"
                                value={filterConfig.type}
                                onChange={(e) => handleFilterChange(e)}
                            >
                                <option hidden value="">Select</option>
                                <option value="warehouse">Warehouse</option>
                                <option value="branch">Branch</option>
                            </Form.Select>
                        </Col>
                        <Col xs={6} lg={2}>
                            <DatePicker
                                autoComplete="off"
                                selected={filterConfig.date_from}
                                name="date_from"
                                placeholderText={"Select Date From"}
                                onChange={(date) => {
                                    setFilterConfig((prev) => {
                                        return { ...prev, date_from: date };
                                    });
                                }}
                                fixedHeight
                                className="date-filter me-4 form-control"
                                showYearDropdown
                                dateFormatCalendar="MMMM"
                                yearDropdownItemNumber={20}
                                scrollableYearDropdown
                            />
                        </Col>
                        <Col xs={6} lg={2}>
                            <DatePicker
                                autoComplete="off"
                                selected={filterConfig.date_to}
                                name="date_to"
                                placeholderText={"Select Date To"}
                                onChange={(date) => {
                                    setFilterConfig((prev) => {
                                        return { ...prev, date_to: date };
                                    });
                                }}
                                fixedHeight
                                className="date-filter ps-label-content me-5 form-control"
                                showYearDropdown
                                dateFormatCalendar="MMMM"
                                yearDropdownItemNumber={20}
                                scrollableYearDropdown
                            />
                        </Col>
                    </Row>
                    <div className="mb-2" />

                    <div className="below">
                        <TableWithDynamicPagination
                            tableHeaders={[
                                "-",
                                "TRANSFER DATE",
                                "BRANCH",
                                "TRANSFER NO.",
                                "CUSTOMER",
                                "TYPE",
                                "TIME",
                                "DRIVER",
                                "PLATE NO.",
                                "DELIVERY PERSONNEL",
                                "ACTIONS",
                            ]}
                            headerSelector={[
                                "-",
                                "transfer_date",
                                "branch_name",
                                "transfer_number",
                                "customer",
                                "type",
                                "transfer_time",
                                "driver",
                                "plate_no",
                                "delivery_personnel",
                            ]}
                            tableType="gatepass"
                            tableData={tableData}
                            showLoader={showLoader}
                            ViewBtn={(row) => ViewBtn(row)}
                            PendingBtn={(row) => TransferBtn(row)}
                            ActionBtn={(row) => ActionBtn(row)}
                            // used in dynamic pagination
                            totalItems={totalItems}
                            currentPage={currentPage}
                            itemsPerPage={itemsPerPage}
                            handlePageChange={handlePageChange}
                        />
                    </div>
                    <div className="mb-2" />
                </div>
            </div>
            <DeleteModal
                show={showDeleteModal}
                onHide={() => handleCloseDeleteModal()}
                text="gatepass"
                onDelete={() => handleDeleteGatePass()}
                isClicked={isClicked}
            />
            <Modal show={showAddModal} onHide={() => setShowAddModal(false)} size="lg" centered>
                <Modal.Body>
                    <span className="PI-modal-header">
                        ADD GATE PASS
                    </span>
                    <div className="PI-modal-body mt-3">
                        <span className="PI-modal-label">
                            TRANSFER NO.
                        </span>
                        <Select
                            className="react-select-container"
                            classNamePrefix="react-select"
                            placeholder="Select transfer..."
                            options={transfers}
                            onChange={(e) => setTransferId(e.value)}
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer className="PI-modal-buttons">
                    <button
                        type="button"
                        onClick={() => setShowAddModal(false)}
                        className="button-secondary"
                    >
                        Close
                    </button>
                    <button
                        type="button"
                        onClick={() =>
                            navigate("/gatepass/add/" + transferId.split("|")[0], {
                                        state: {transfer_data: { branch_from: transferId.split("|")[1], 
                                                 branch_from_name: transferId.split("|")[2], }}
                                    })
                        }
                        className="button-primary"
                    >
                        Continue
                    </button>
                </Modal.Footer>
            </Modal>
            <Footer/>
        </div>
    );
}
